import { render, staticRenderFns } from "./YaoXing.vue?vue&type=template&id=4dc1896a&scoped=true"
import script from "./YaoXing.vue?vue&type=script&lang=js"
export * from "./YaoXing.vue?vue&type=script&lang=js"
import style0 from "./YaoXing.vue?vue&type=style&index=0&id=4dc1896a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc1896a",
  null
  
)

export default component.exports